import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icons/arrow-left.svg'


const _withScopeId = n => (_pushScopeId("data-v-5da14394"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "alumnuses" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "landing__title--secondary" }, "Выпускники", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "landing__description" }, "Доля выпускников Института экономики и управления АПК, трудоустроившихся не позднее одного года после выпуска, составляет более 98 %.", -1))
const _hoisted_4 = { class: "alumnuses__carousel carousel" }
const _hoisted_5 = { class: "carousel__body" }
const _hoisted_6 = { class: "alumnus__name" }
const _hoisted_7 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("img", {
        class: "carousel__left-arrow",
        src: _imports_0,
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.prevSlide()))
      }),
      _createElementVNode("div", _hoisted_5, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.alumnuses, (alumnus, index) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "carousel__slide alumnus",
            key: index
          }, [
            _createElementVNode("div", {
              class: "alumnus__image",
              style: _normalizeStyle({backgroundImage: `url(${require('../../assets/alumnuses/' + alumnus.image)})`})
            }, null, 4),
            _createElementVNode("div", _hoisted_6, _toDisplayString(alumnus.name), 1),
            _createElementVNode("p", {
              class: "alumnus__description",
              innerHTML: alumnus.desciption
            }, null, 8, _hoisted_7)
          ]))
        }), 128))
      ])
    ])
  ]))
}